import {document, download} from '@sail/icons/react/Icon';
import prettyBytes from 'pretty-bytes';
import {Icon, Divider, view} from '@sail/ui';

type Props = {
  name: string;
  size: number;
  clickable?: boolean;
};

export const AttachmentInfoNext = ({name, size, clickable = false}: Props) => {
  return (
    <view.div
      className="attachment-info"
      css={{
        position: 'relative',
        border: '1px solid',
        borderColor: 'border',
        borderRadius: '8px',
        padding: 'space.150',
        width: 'fill',
        backgroundColor: 'white',
        ...(clickable ? {':hover': {boxShadow: 'large'}} : {}),
      }}
    >
      <view.div css={{stack: 'x', alignY: 'center'}}>
        <view.span css={{font: 'body.small.emphasized'}}>
          <Icon
            className="download-icon"
            size="xsmall"
            icon={download}
            css={{
              display: 'none',
              position: 'absolute',
              top: 'small',
              right: 'medium',
              ...(clickable
                ? {'.attachment-info:hover &': {display: 'block'}}
                : {}),
            }}
          />
          <Icon size="xsmall" icon={document} css={{marginRight: 'xsmall'}} />
          <view.span>File upload</view.span>
        </view.span>
        <Divider css={{marginX: 'small'}} />
        <view.span css={{font: 'label.small'}}> {prettyBytes(size)}</view.span>
      </view.div>
      <view.div
        css={{
          color: 'action.primary',
          font: 'label.medium.emphasized',
          marginTop: 'xsmall',
        }}
      >
        {name}
      </view.div>
    </view.div>
  );
};
